import React from 'react';
import { financial } from 'utils/number';
import _ from 'lodash';
import { UploadTips } from 'containers/OutWorkbench/ProjectDetail/Show/Detail/Bottom/Making/XiaoHao/utils';
import { UploadFile } from 'modules/types/commons/file';
import {
  FileListShow,
  MockInputShow,
  MoneyShow,
  SelectShow,
} from 'containers/OutBidding/components/utils';
import isBlank from 'utils/object';

export enum BiddingState {
  /** 竞选通过  */
  BIDDING_PASS = 'BIDDING_PASS',
  /** 方案确认通过  */
  BIDDING_CONFIRM_PASS = 'BIDDING_CONFIRM_PASS',
  /** 中选通过  */
  BIDDING_WIN = 'BIDDING_WIN',
}

export const getFormItemList = (params: any = {}) => {
  const { optionsMap, formData, setFormData, editFields } = params;
  const { quote_currencies = [] } = optionsMap;

  const {
    quote_currency,
    quote_price,
    tender_plan_attach_blob_ids,
    is_win,
    quote_price_attach_blob_ids,
  } = formData;

  const getUploadConfig = (fileList: any[] = []) => {
    const tmp = {
      componentClass: 'upload',
      showUploadList: { showRemoveIcon: true },
      multiple: true,
      fileList,
      uploadAction: '/api/outsource/v2/java_proxy/attachments/upload',
      onChange({ formItemKey, value }: any) {
        setFormData({
          ...formData,
          [formItemKey]: value.fileList,
        });
      },
      uploadTips: <UploadTips showDownloadTemp={false} />,
      data: (file: UploadFile) => {
        return {
          model: 'V2::Demand',
          filename: file.name,
        };
      },
      showComponent: <FileListShow list={fileList} />,
    };
    return tmp;
  };
  const supplier = formData?.bidding_suppliers?.[0]
  const formList: any[] = [
    {
      key: 'bidding_supplier_name',
      label: '供应商编号',
      required: false,
      childProps: {
        componentClass: 'input',
        value: supplier?.supplier_index || supplier?.bidding_supplier_name,
      }
    },
    {
      key: 'tender_plan_attach_blob_ids',
      label: '比选方案',
      required: true,
      childProps: getUploadConfig(tender_plan_attach_blob_ids),
    },
    editFields.includes('quote_price')
      ? {
          key: 'quote_price',
          label: '报价金额',
          required: true,
          childProps: {
            componentClass: 'inputNumber',
            hideHandle: true,
            min: 0,
            precision: 2,
            formatter: (value: number) => financial(value, true),
            value: quote_price,
          },
        }
      : null,
    editFields.includes('quote_price')
      ? {
          key: 'quote_currency',
          label: <span style={{ visibility: 'hidden' }}>__</span>,
          className: 'currency',
          childProps: {
            componentClass: 'select',
            options: quote_currencies,
            mode: 'select',
            value: quote_currency,
            showComponent: (
              <SelectShow id={quote_currency} options={quote_currencies} />
            ),
          },
        }
      : null,
    !editFields.includes('quote_price')
      ? {
          key: 'quote_price',
          label: '报价金额',
          childProps: {
            showComponent: <MoneyShow value={quote_price} currency={quote_currency} options={quote_currencies} />
          }
        }
      : null,
    {
      key: 'quote_price_attach_blob_ids',
      label: '报价文件',
      childProps: getUploadConfig(quote_price_attach_blob_ids),
    },
    {
      key: 'is_win',
      label: '是否中选',
      childProps: {
        componentClass: 'input',
        value: is_win,
        showComponent: (
          <MockInputShow text={isBlank(is_win) ? '--' : is_win ? '是' : '否'} />
        ),
      },
    },
  ];

  formList.forEach((v) => {
    if (!v) {
      return;
    }

    v.itemColProps = { span: 4 };

    if (['quote_price', 'quote_currency'].includes(v.key) && editFields.includes('quote_price')) {
      v.itemColProps = { span: 2 };
    }

    if (v.childProps && !v.childProps.onChange) {
      v.childProps.onChange = ({ formItemKey, value }: any) => {
        const newFormData = _.cloneDeep(formData);
        newFormData[formItemKey] = value;
        setFormData(newFormData);
      };
    }

    if (v.childProps) {
      v.childProps.isShow = true;
    }

    if (editFields.includes(v.key) && v.childProps) {
      v.childProps.isShow = false;
    }

    if (['is_win'].includes(v.key) && v.childProps) {
      v.childProps.isShow = true;
    }
  });

  return formList.filter((v) => !!v);
};
